import { StandardEvents } from '@shopify/events';

/**
 * Prevent accidental duplicate product-form adds while the first add is still
 * being processed. This protects PDP, quick-add, and sticky-button flows that
 * ultimately submit the same product-form-component.
 */
if (!window.__baseformAddToCartGuard) {
  const pendingForms = new WeakSet();
  const lastSubmitAt = new WeakMap();
  const rapidSubmitWindow = 800;

  Object.defineProperty(window, '__baseformAddToCartGuard', {
    value: true,
    configurable: false,
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      const productForm = form?.closest('product-form-component');
      if (!productForm) return;

      const now = performance.now();
      const lastSubmit = lastSubmitAt.get(productForm) ?? -Infinity;
      const isRapidRepeat = now - lastSubmit < rapidSubmitWindow;

      if (pendingForms.has(productForm) || isRapidRepeat) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      lastSubmitAt.set(productForm, now);
    },
    true
  );

  document.addEventListener(
    StandardEvents.cartLinesUpdate,
    (event) => {
      if (event.action !== 'add') return;

      const target = event.target instanceof Element ? event.target : null;
      const productForm = target?.closest('product-form-component');
      if (!productForm) return;

      pendingForms.add(productForm);

      const release = () => pendingForms.delete(productForm);
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(release, release);
      } else {
        window.setTimeout(release, 2000);
      }
    },
    true
  );
}
